/** Account row from Interstellar `GET /account/` */
export interface InterstellarAccount {
  id: number;
  name: string;
  /** Cosmos account UUID this Interstellar account is linked to. */
  cosmos_account_id?: string | null;
  phone_number?: string | null;
  call_rescue_number?: string | null;
  search_index_name?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  zip_code?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  sip_trunk?: string | null;
  created_at?: string | null;
  email?: string | null;
  timezone?: string | null;
  updated_at?: string | null;
  status?: 'active' | 'inactive' | 'suspended';
  /** ID of the FreeSWITCH group this account shares. Null/absent for dedicated instances. */
  freeswitch_group_id?: number | null;
}

/** Paginated envelope from Interstellar */
export interface AccountsListResponse {
  total_count?: number;
  page?: number;
  page_size?: number;
  accounts?: InterstellarAccount[];
  /** Legacy / alternate shapes */
  results?: InterstellarAccount[];
}

/** @deprecated Use InterstellarAccount — kept for existing imports */
export type AccountWithLocation = InterstellarAccount;

export function accountIsGeoreferenced(account: InterstellarAccount): boolean {
  const { latitude, longitude } = account;
  if (latitude == null || longitude == null) {
    return false;
  }
  const lat = Number(latitude);
  const lng = Number(longitude);
  return !Number.isNaN(lat) && !Number.isNaN(lng);
}
